import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { formatISO, startOfDay } from "date-fns";
import { _3_DAYS } from "../../../constants/durations";
import { useSpace } from "../../../hooks/useSpace";
import { UpcomingEventWithSubTopic } from "../../../types";
import { keys } from "./keys";

async function fetchUpcomingEvents(spaceId: string): Promise<UpcomingEventWithSubTopic[]> {
  const today = formatISO(startOfDay(new Date()), { representation: 'date' });

  // Keep events whose end date is today or later. `end_date` is nullable, so
  // fall back to `date` when it is missing (same logic as the calendar_items view).
  const { data, error } = await apiClient
    .from('events')
    .select('*, sub_topics!inner(id, name, topics!inner(space_id))')
    .eq('sub_topics.topics.space_id', spaceId)
    .or(`end_date.gte.${today},and(end_date.is.null,date.gte.${today})`)
    .order('date', { ascending: true });

  if (error) {
    throw error;
  }

  return (data ?? []) as unknown as UpcomingEventWithSubTopic[];
}

export function useGetUpcomingEvents() {
  const { currentSpace } = useSpace();

  return useQuery({
    queryKey: keys.upcoming(currentSpace?.id ?? ''),
    queryFn: () => fetchUpcomingEvents(currentSpace!.id),
    enabled: !!currentSpace?.id,
    staleTime: _3_DAYS,
  });
}
